module.exports = __webpack_public_path__ + "static/media/v1.3627ffd1.mp4";